produtos.component('produtos.produtosComponent', {
    templateUrl: 'produtos/produtos.html',
    controller: 'produtos.produtosController'
});

produtos.controller('produtos.produtosController', ['$scope', 'coreLanguage', '$state', 'coreFb', '$timeout', function($scope, $text, $state, $fb, $timeout) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.filter = {};

    const _tableRerender=()=>{
        let config = angular.copy($ctrl.tableObj);
        $ctrl.tableObj = null;
        $timeout(()=>{ $ctrl.tableObj = config; }, 100);
    };

    const _getProdutos=()=>{
        $state.params.showGlobalLoading = true;
        $ctrl.tableObj.data = [];

        //$fb.db.list('cad_produtos', [{limit:[500]}]).then(list=>{
        $fb.db.list('cad_produtos', [{where:['criacao.idUsuario', '==', $ctrl.idUsuario]}, {limit:[500]}]).then(list=>{

            $ctrl.tableObj.data = list.map((item)=>{
                return {
                    id: item.id,
                    fotoUrl: item.data.fotoUrl || 'assets/images/user-blank.jpg',
                    nome: item.data.nome || null,
                    indice: `${item.data.nome || ''}`,
                    interno: !!item.data.interno,
                    docPath: item.path
                }
            }).filter(item=>!item.interno);

            $state.params.showGlobalLoading = false;
            _tableRerender();
        });        
    };

    const _editRegistro=(value)=>{
        $state.go('admin.editarProduto', {idProduto: value.id });
    };

    const _confirmProduto=()=>{
        $ctrl.cfgProdutos.isLoading=true;

        if($ctrl.cfgProdutos.dados.docPath){
            if($ctrl.cfgProdutos.dados.indice){ delete $ctrl.cfgProdutos.dados.indice; }

            delete $ctrl.cfgProdutos.dados.alteracao;
            delete $ctrl.cfgProdutos.dados.criacao;

            $fb.db.update($ctrl.cfgProdutos.dados.docPath, $ctrl.cfgProdutos.dados).then((res)=>{
                $ctrl.cfgProdutos.show = false;
                $ctrl.cfgProdutos.isLoading=false;
                $state.reload();
            });
        }else{

            $ctrl.cfgProdutos.dados.niveis = ["starter", "pro", "partner"];

            $fb.db.add('cad_produtos', $ctrl.cfgProdutos.dados).then((res)=>{
                $ctrl.cfgProdutos.show = false;
                $ctrl.cfgProdutos.isLoading=false;
                $state.reload();
            });
        }
    };

    const _deleteProduto=()=>{
        $ctrl.cfgProdutos.isLoading=true;

        if($ctrl.cfgProdutos.dados.docPath){
            $fb.db.del($ctrl.cfgProdutos.dados.docPath).then((res)=>{
                $ctrl.cfgProdutos.show = false;
                $ctrl.cfgProdutos.isLoading=false;

                $state.reload();
            });
        }
    };

    $ctrl.setTableFilter=(value, field)=>{
        if(field==="search"){
            if(!value.length){
                delete $ctrl.filter.indice;
            }else{
                $ctrl.filter.indice = value;
            }
        }else{
            if(!!value){
                $ctrl.filter[field] = value;
            }else{
                delete $ctrl.filter[field];
            }
        }
    };

    $ctrl.addRegistroModal=()=>{
        $ctrl.cfgProdutos.dados = {};
        $ctrl.cfgProdutos.title = $text.add+' '+$text.course;
        $ctrl.cfgProdutos.show = true;
    };

    $ctrl.tableObj = {
        pageSize: 100,
        pageCount: 1,
        columns:[
            {title: '', key:'fotoUrl', type:'image', export:false},
            {title: $text.name.toUpperCase(), width:'25%', key:'nome', type:'text', export:true}
        ],
        data:[],
        actions:{
            enable: {edit:true, view:true, delete:true},
            edit: _editRegistro,
            view: _editRegistro
        },
        bulkActions:{
            enable: {delete:true}
        }
    };

    $ctrl.cfgProdutos = {
        show:false,
        dados: {},
        isLoading:false,
        enableDelete:true,
        confirm: _confirmProduto,
        delete: _deleteProduto
    };

    $ctrl.$onInit = () => {
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idMaster || $fb.auth.getIdToken().claims.idUsuario;

        $state.params.showGlobalLoading = false;

        _getProdutos();
    };
    
}]);